import { DataTable } from "mantine-datatable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Text, TextInput } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchProduct } from "../../../redux/actions/productAction";
import { Button } from '@mantine/core';
import { fetchPrinterModel, storePrinterModel } from "../../../redux/actions/printerAction";
import { IconSearch } from "@tabler/icons-react";
const ModelListTable = ({ PAGE_SIZE = 30 }) => {
    const [data, setProductData] = useState([]);
    const [dataOfTable, setDataOfTable] = useState(data || []);
    const [page, setPage] = useState(1);
    const { loading, PrinterModelsList } = useSelector((state) => state?.printers);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [records, setRecords] = useState(dataOfTable?.slice(0, PAGE_SIZE) || []);

    const [query, setQuery] = useState('');

    useEffect(() => {
        setDataOfTable(
            data?.filter(({ brand_name }) => {
                return brand_name?.toLowerCase()?.includes(query?.trim()?.toLowerCase());
            })
        );
    }, [query]);



    useEffect(() => {
        setDataOfTable(data);
    }, [data]);



    useEffect(() => {
        dispatch(fetchPrinterModel());
    }, []);

    useEffect(() => {
        setProductData(PrinterModelsList)
    }, [PrinterModelsList]);

    useEffect(() => {
        const from = (page - 1) * PAGE_SIZE;
        const to = from + PAGE_SIZE;
        setRecords(dataOfTable?.slice(from, to));
    }, [page, dataOfTable]);

    const handleDelete = async (id) => {
        // await dispatch(deleteProduct(id)).then((res) => {
        //     if (dataOfTable?.length !== 1 && records.length === 1) {
        //         setPage(page - 1);
        //     }
        // });
    };



    const product_columns = [
        {
            accessor: "SNO",
            title: <Text>#</Text>,
            width: "auto",
            render: (record, i) => <Text>{i + 1}</Text>,
        },
        {
            accessor: "name",
            width: "auto",
            title: "Model",

        },

        {
            accessor: "brand_name",
            width: "auto",
            title: 'Brand',
            filter: (
                <TextInput
                    label="Brand"
                    placeholder="Search Brand..."
                    icon={<IconSearch size={16} />}
                    value={query}
                    onChange={(e) => setQuery(e.currentTarget.value)}
                />
            ),

        },

        {
            accessor: "actions",
            width: "auto",
            textAlignment: "right",
            title: <Text>Actions</Text>,
            render: (record) => (
                <div>

                </div>
            ),
        },
    ];

    const [OpenModel, setOpenModel] = useState(false)

    return (
        <div>
            <div className="d-flex mb-3 justify-content-between align-items-end">
                <h3 className="m-0" onClick={() => dispatch(fetchPrinterModel())}>Models List</h3>
                <Button
                    className="text-uppercase"
                    variant="gradient"
                    gradient={{ from: 'lime', to: 'teal', deg: 90 }}
                    onClick={() => setOpenModel(true)}>
                    Add New Model
                </Button>
            </div>
            <DataTable
                className="data-table-with-actions"
                withBorder
                records={records}
                withColumnBorders
                striped
                highlightOnHover
                verticalSpacing={10}
                columns={
                    product_columns
                }
                totalRecords={dataOfTable?.length}
                recordsPerPage={PAGE_SIZE}
                page={page}
                onPageChange={(p) => setPage(p)}
                fetching={loading}
                minHeight={400}
                loaderVariant="dots"
                noRecordsText="No records found"
                paginationText={({ from, to, totalRecords }) =>
                    `Records ${from} - ${to} of ${totalRecords}`
                }
                paginationSize="md"
            />
        </div>
    );
}

export default ModelListTable